<p-contextMenu
  #contextMenu
  [model]="contextMenuItems"
  (onHide)="onContextMenuHide()"
></p-contextMenu>

<p-dialog
  header="Uložiť nový pohľad"
  [(visible)]="newPresetDialogVisible"
  [modal]="true"
>
  <form
    [formGroup]="newPresetForm"
    class="flex flex-col gap-3"
    (submit)="saveNewPreset()"
  >
    <div class="p-field flex flex-col mb-4">
      <label for="name" class="mb-1">Názov pohľadu</label>
      <input
        id="name"
        type="text"
        pInputText
        formControlName="name"
        class="w-full"
      />
    </div>

    <p-button
      label="Uložiť"
      type="submit"
      [loading]="presetsLoading()"
      [disabled]="!newPresetForm.valid"
    ></p-button>
  </form>
</p-dialog>

<p-dialog
  class="table-settings"
  [(visible)]="tableSettingsVisible"
  [modal]="true"
  header="Nastavenia zobrazenia"
  [style]="{ 'max-width': '700px' }"
>
  <p-tabView [(activeIndex)]="activeSettingsIndex">
    <p-tabPanel header="Stĺpce">
      <div class="flex flex-col gap-3 p-1 max-h-[450px] overflow-y-auto">
        @for (column of asortedColumns; track $index) {
        <p-checkbox
          [value]="column"
          [label]="column.label"
          [binary]="true"
          [ngModel]="isColumnVisible(column)"
          (ngModelChange)="onColumnVisibleChange(column, $event)"
        ></p-checkbox>
        }
      </div>
    </p-tabPanel>

    <p-tabPanel header="Všeobecné">
      <div class="flex flex-col gap-3">
        <p-checkbox
          [value]="true"
          [label]="'Zobrazovať aktívne filtre'"
          [binary]="true"
          [ngModel]="showActiveFilters"
          (ngModelChange)="onShowActiveFiltersChange($event)"
        />

        <p class="text-sm text-gray-600">
          Zobrazí aktívne filtre pod tabuľkou. Filtre môžete zrušiť kliknutím na
          ne.
        </p>

        <p-divider />

        <p-button
          class="p-button-sm"
          icon="pi pi-refresh"
          label="Obnoviť nastavenia"
          size="small"
          severity="danger"
          (click)="reset()"
        >
        </p-button>

        <p class="text-sm text-gray-600">
          Obnoví nastavenia tabuľky na predvolené hodnoty (poradie stĺpcov,
          veľkosť, a pod.)
        </p>
      </div>
    </p-tabPanel>
    @if(presetsEnabled()){
    <p-tabPanel header="Pohľady">
      <div
        cdkDropList
        (cdkDropListDropped)="onPresetReorder($event)"
        class="space-y-1 presets-list"
      >
        @for (preset of sortedPresets(); track preset.id) {

        <p-inputGroup
          cdkDrag
          [ngClass]="{
                  'group preset-item h-11': true,
                  active: preset.hash === activePresetHash(),
                }"
        >
          <p-inputGroupAddon
            cdkDragHandle
            [cdkDragHandleDisabled]="editingPreset()"
            [ngClass]="{
                    'cursor-move flex items-center gap-1 text-gray-700 pl-2 py-1': true,
                    'opacity-40 cursor-not-allowed': editingPreset(),
                  }"
          >
            <span class="pi pi-bars"></span>
          </p-inputGroupAddon>

          @if (editingPresetValue().id === preset.id) {
          <input
            #presetNameInput
            type="text"
            pInputText
            [ngModel]="editingPresetValue().name"
            (ngModelChange)="patchEditingPreset({ name: $event })"
            (keyup.enter)="saveEditingPreset()"
            (keyup.escape)="setEditingPreset(null)"
          />
          } @else {
          <span
            pInputText
            (dblclick)="setEditingPreset(preset)"
            class="flex items-center h-full"
          >
            {{ preset.name }}
          </span>
          } @if (preset.hash === activePresetHash() && editingPreset() === null)
          {
          <p-inputGroupAddon>
            <button
              pButton
              type="button"
              icon="pi pi-exclamation-triangle"
              (click)="saveIntoPreset(preset)"
              class="p-button-sm p-button-text p-button-warn"
              [pTooltip]="'Uložiť zmeny'"
              [disabled]="editingPreset() !== null"
              [tooltipDisabled]="editingPreset() !== null"
            ></button>
          </p-inputGroupAddon>
          } @if (editingPresetValue().id === preset.id) {
          <p-inputGroupAddon>
            <button
              pButton
              type="button"
              icon="pi pi-check"
              class="p-button-sm p-button-text p-button-success"
              (click)="saveEditingPreset()"
              [pTooltip]="'Uložiť'"
            ></button>
          </p-inputGroupAddon>

          <p-inputGroupAddon>
            <button
              pButton
              type="button"
              icon="pi pi-times"
              class="p-button-sm p-button-text p-button-secondary"
              (click)="setEditingPreset(null)"
              [pTooltip]="'Zrušiť'"
            ></button>
          </p-inputGroupAddon>
          } @else {
          <p-inputGroupAddon>
            <button
              pButton
              type="button"
              icon="pi pi-pencil"
              class="p-button-sm p-button-text"
              (click)="setEditingPreset(preset)"
              [pTooltip]="'Upraviť'"
              [disabled]="editingPreset() !== null"
            ></button>
          </p-inputGroupAddon>
          }

          <p-inputGroupAddon>
            <button
              pButton
              type="button"
              icon="pi pi-upload"
              (click)="applyPreset(preset)"
              class="p-button-sm p-button-text"
              [pTooltip]="'Použiť pohľad'"
              [disabled]="editingPreset() !== null"
              [tooltipDisabled]="editingPreset() !== null"
            ></button>
          </p-inputGroupAddon>

          <p-inputGroupAddon>
            <button
              pButton
              type="button"
              icon="pi pi-trash"
              class="p-button-sm p-button-text p-button-danger"
              [pTooltip]="'Zmazať pohľad'"
              (click)="deletePreset(preset)"
              [disabled]="editingPreset() !== null"
              [tooltipDisabled]="editingPreset() !== null"
            ></button>
          </p-inputGroupAddon>
        </p-inputGroup>

        @if (!$last) {
        <p-divider class="my-0"></p-divider>
        } } @empty {
        <div class="flex flex-col items-center">
          <p class="text-center text-gray-600 py-4">
            Zatiaľ neboli vytvorené žiadne pohľady.
          </p>

          <button
            pButton
            type="button"
            label="Vytvoriť nový pohľad"
            icon="pi pi-plus"
            (click)="newPresetDialogVisible.set(true)"
          ></button>
        </div>
        }
      </div>
    </p-tabPanel>
    }
  </p-tabView>
</p-dialog>

<p-menu #presetsMenu [model]="presetsMenuItems()" appendTo="body" popup>
</p-menu>

<p-table
  #dataTable
  [lazy]="true"
  [reorderableColumns]="true"
  [value]="tableData"
  [columns]="columns"
  [sortMode]="'multiple'"
  [multiSortMeta]="multiSortMeta"
  [filters]="filters"
  [rows]="perPage"
  [totalRecords]="total"
  [first]="first"
  [paginator]="true"
  [rowsPerPageOptions]="perPageOptions"
  [showCurrentPageReport]="true"
  [currentPageReportTemplate]="'Zobrazené: {first} až {last} z {totalRecords}'"
  [showJumpToPageInput]="true"
  (onLazyLoad)="onLazyLoad($event)"
  [lazyLoadOnInit]="false"
  [contextMenu]="contextMenu"
  [contextMenuSelection]="selectedRow"
  (contextMenuSelectionChange)="onContextMenuSelectionChange($event)"
  [scrollable]="true"
  [scrollHeight]="'flex'"
  [columnResizeMode]="'expand'"
  [tableStyle]="{ 'min-width': '100%' }"
  [paginatorDropdownAppendTo]="'body'"
  [stateKey]="stateKey"
  [stateStorage]="'local'"
  (onStateSave)="onStateSave($event)"
  (onStateRestore)="onStateRestore($event)"
  [rowExpandMode]="config.expandMode ?? 'single'"
  (onRowExpand)="onRowExpand($event)"
  (onRowCollapse)="onRowCollapse($event)"
  (onColReorder)="onColReorder($event)"
  dataKey="id"
>
  <ng-template pTemplate="caption">
    @if (hasBulkActions && selectedIds().size > 0) {

    <div
      class="flex items-center gap-2 px-4 py-2 bg-primary-50 border-b border-primary-200 flex-wrap"
    >
      @if (bulkProgress(); as progress) {
      <span class="text-sm font-medium text-primary-700">
        Spracováva sa: {{ progress.current }} / {{ progress.total }}
      </span>

      <p-progressBar
        [value]="(progress.current / progress.total) * 100"
        [style]="{ height: '6px', width: '120px' }"
        [showValue]="false"
      ></p-progressBar>
      } @else {
      <span class="text-sm font-medium text-primary-700">
        Vybraté: {{ selectedIds().size }} / {{ tableData.length }}
      </span>
      } @if (bulkActionsRunning()) {
      <button
        pButton
        type="button"
        icon="pi pi-stop-circle"
        label="Zrušiť"
        class="p-button-sm p-button-outlined p-button-danger"
        [pTooltip]="'Zrušiť prebiehajúcu akciu'"
        (click)="cancelBulkAction()"
      ></button>
      } @else {
      <button
        pButton
        type="button"
        icon="pi pi-times"
        class="p-button-sm p-button-text p-button-secondary"
        [pTooltip]="'Zrušiť výber'"
        (click)="clearBulkSelection()"
      ></button>
      }

      <div class="h-4 w-px bg-gray-300 mx-2"></div>

      <div class="flex items-center gap-1 ml-2">
        @for (action of config.bulkActions; track $index) { @if (action.visible
        !== false) {
        <button
          pButton
          type="button"
          [icon]="action.icon ?? ''"
          [label]="action.label"
          [disabled]="bulkActionsRunning() || action.disabled"
          [ngClass]="[
            'p-button-sm',
            'p-button-' + resolveBulkActionColor(action),
            action.styleClass ?? ''
          ]"
          (click)="executeBulkAction(action)"
        ></button>
        } }
      </div>
    </div>
    }
    <div
      class="flex sm:flex-nowrap justify-between items-start gap-2 px-4 py-2.5 relative"
      [ngClass]="{
        'flex-wrap-reverse': config.header?.newButton || config.header?.actions
      }"
    >
      <p-progressBar
        [ngClass]="{
          'absolute top-0 left-0 right-0': true,
          'opacity-0': !loading
        }"
        [style]="{
          height: '4px',
        }"
        mode="indeterminate"
      />
      <div class="flex flex-wrap items-center gap-2 w-full sm:w-auto">
        <div class="flex flex-row flex-nowrap w-full sm:w-auto">
          <span class="p-input-icon-right mr-auto w-full sm:w-auto">
            <i class="pi pi-search" *ngIf="showSearch"></i>
            <input
              pInputText
              #searchInput
              type="text"
              class="w-full"
              placeholder="Hľadať..."
              [formControl]="searchControl"
              pTooltip="Pre vyhľadávanie v strede slov zadajte %hladam"
              [ngClass]="{
                'hidden sm:block': !showSearch,
                'block w-full': showSearch
              }"
            />
          </span>

          <p-button
            *ngIf="hasActiveFilters"
            [text]="true"
            class="p-button-sm hidden sm:block"
            icon="pi pi-filter-slash"
            severity="secondary"
            (click)="clear(dataTable)"
            [pTooltip]="'Zrušiť všetky filtre'"
          ></p-button>
        </div>

        <div
          class="flex flex-row sm:flex-wrap overflow-x-auto lg:flex-nowrap py-2"
          *ngIf="config.header?.quickFilters as quickFilters"
        >
          @for (filter of quickFilters; track $index) {
          <div
            class="flex items-center font-normal pl-2 xl:pl-4 py-2 text-nowrap"
          >
            <p-radioButton
              [value]="filter"
              [label]="filter.label"
              [(ngModel)]="currentQuickFilter"
              (onClick)="quickFilterChange()"
            ></p-radioButton>
          </div>
          }
        </div>
      </div>

      <div class="sm:ml-auto">
        <ng-container *ngIf="config.header?.newButton as btnConfig">
          <p-splitButton
            #splitButton
            *ngIf="config.header?.actions as actions; else simpleButton"
            [label]="btnConfig.label"
            [disabled]="btnConfig.disabled"
            [icon]="btnConfig.icon ?? ''"
            (onClick)="handleHeaderButtonClick($event)"
            [model]="actions"
            styleClass="p-button-sm"
          >
          </p-splitButton>

          <ng-template #simpleButton>
            <button
              pButton
              [label]="btnConfig.label || ''"
              [routerLink]="btnConfig.routerLink"
              [disabled]="btnConfig.disabled"
              (click)="btnConfig.command?.()"
              [icon]="btnConfig.icon ?? ''"
              type="button"
              class="p-button-sm"
            ></button>
          </ng-template>
        </ng-container>

        @if(!config.header?.newButton) {
        <ng-container *ngIf="config.header?.actions as actions">
          <div>
            <button
              pButton
              class="p-button-sm p-button-text"
              icon="pi pi-ellipsis-v"
              (click)="actionsMenu.toggle($event)"
            ></button>
            <p-menu
              #actionsMenu
              [model]="actions"
              [popup]="true"
              [appendTo]="'body'"
            ></p-menu>
          </div>
        </ng-container>
        }
      </div>

      <div class="space-x-2 flex">
        <button
          pButton
          *ngIf="hasActiveFilters"
          class="p-button-sm p-button-text p-button-secondary sm:hidden"
          icon="pi pi-filter-slash"
          (click)="clear(dataTable)"
          [pTooltip]="'Zrušiť všetky filtre'"
        ></button>

        <button
          pButton
          class="p-button-sm p-button-text justify-self-end sm:hidden"
          icon="pi pi-search"
          (click)="toggleSearch()"
        ></button>

        @if (config.header?.quickActions) { @for ( action of
        config.header?.quickActions; track action.label || action.icon ) {
        <button
          pButton
          type="button"
          [icon]="action.icon ?? ''"
          [label]="action.label ?? ''"
          [routerLink]="action.routerLink"
          [queryParams]="action.queryParams"
          [severity]="action['severity'] ?? 'primary'"
          [disabled]="action.disabled"
          [pTooltip]="action.tooltip ?? action.label"
          [tooltipPosition]="action.tooltipPosition ?? 'left'"
          [tooltipOptions]="action.tooltipOptions"
          [class]="action.styleClass ?? 'p-button-sm p-button-text'"
          (click)="
                action.command?.({
                  originalEvent: $event,
                  item: action,
                  index: $index,
                })
              "
        ></button>
        } } @if (presetsEnabled()) {
        <div class="relative" *ngIf="activePreset() as preset">
          @if (activePresetDirty()) {
          <div
            class="z-10 absolute h-2.5 w-2.5 bg-warn-600 border-surface top-2 right-1.5 rounded-full pointer-events-none"
          ></div>
          }
          <p-button
            [icon]="preset ? 'pi pi-bookmark-fill' : 'pi pi-bookmark'"
            text
            (click)="presetsMenu.toggle($event)"
            [label]="preset && !isMobile() ? preset.name : undefined"
            class="text-nowrap"
          />
        </div>
        <div class="relative" *ngIf="!activePreset()">
          <p-button
            [icon]="'pi pi-bookmark'"
            text
            (click)="presetsMenu.toggle($event)"
          />
        </div>
        }

        <button
          pButton
          class="p-button-sm p-button-text"
          icon="pi pi-sliders-v"
          [pTooltip]="'Nastavenia zobrazenia'"
          [tooltipOptions]="{ showDelay: 300 }"
          (click)="showTableSettings()"
        ></button>
      </div>
    </div>
  </ng-template>

  <ng-template pTemplate="header" let-columns>
    <tr>
      <th *ngIf="hasBulkActions" class="py-0">
        <p-checkbox
          [binary]="true"
          [ngModel]="allRowsSelected"
          (ngModelChange)="toggleAllSelection()"
          [pTooltip]="allRowsSelected ? 'Zrušiť výber' : 'Vybrať všetky'"
          [tooltipOptions]="{ showDelay: 300 }"
        ></p-checkbox>
      </th>
      <th *ngIf="isExpandable" class="py-0"></th>
      <th
        *ngFor="let column of columns"
        [pSortableColumn]="columnSort(column)"
        pReorderableColumn
        [ngClass]="{
          hidden: !isColumnVisible(column),
          'align-top': true
        }"
      >
        <div class="flex items-center text-nowrap">
          {{ columnLabel(column) }}
          <p-sortIcon
            *ngIf="columnSort(column)"
            [field]="column.key"
          ></p-sortIcon>
          <kon-resource-table-column-filter
            *ngIf="column.filter"
            [column]="column"
            [type]="getFilterType(column)"
            [label]="columnLabel(column)"
            [options]="getFilterOptions(column)"
            [columnFilterOperator]="columnFilterOperator"
          >
          </kon-resource-table-column-filter>
        </div>

        @if (column.subLabel) {
        <div class="text-xs text-gray-500 text-nowrap">
          {{ column.subLabel }}
        </div>
        }
      </th>

      <th *ngIf="actions.row">
        <!-- Akcie -->
      </th>
    </tr>
  </ng-template>

  <ng-template
    pTemplate="body"
    let-rowData
    let-columns="columns"
    let-expanded="expanded"
  >
    <ng-container
      *ngIf="processDefaultAction(rowData.data) as action; else noDefaultAction"
    >
      <ng-container *ngIf="action.visible !== false; else noDefaultAction">
        <tr
          [ngClass]="action.styleClass ?? ''"
          [pContextMenuRow]="rowData.data"
          [class]="rowClasses(rowData.data)"
        >
          <ng-container
            *ngTemplateOutlet="
              rowTpl;
              context: { $implicit: rowData, columns: columns }
            "
          >
          </ng-container>
        </tr>
      </ng-container>
    </ng-container>

    <ng-template #noDefaultAction>
      <tr [pContextMenuRow]="rowData.data" [class]="rowClasses(rowData.data)">
        <ng-container
          *ngTemplateOutlet="
            rowTpl;
            context: { $implicit: rowData, columns: columns }
          "
        >
        </ng-container>
      </tr>
    </ng-template>

    <ng-template #rowTpl let-rowData let-columns="columns">
      <td
        *ngIf="hasBulkActions"
        class="py-0"
        (click)="$event.stopPropagation()"
      >
        <div class="flex items-center">
          <p-checkbox
            [binary]="true"
            [ngModel]="isRowSelected(rowData.data)"
            [ngModelOptions]="{ standalone: true }"
            (click)="toggleRowSelection(rowData.data, $event)"
          ></p-checkbox>
        </div>
      </td>

      <td
        *ngIf="isExpandable"
        [ngClass]="{ 'py-0': true, 'px-0': hasBulkActions }"
      >
        <p-button
          type="button"
          pRipple
          [pRowToggler]="rowData"
          [text]="true"
          [rounded]="true"
          [plain]="true"
          size="small"
          [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
        />
      </td>

      <td
        *ngFor="let column of columns"
        [class]="column.class"
        [ngClass]="{
          'hidden': !isColumnVisible(column),
        }"
        [class]="'text-nowrap ' + (column.class ?? '')"
      >
        <ng-container
          *ngTemplateOutlet="
            columnTemplate(column) ?? defaultColTpl;
            context: {
              $implicit: getCellFromRow(rowData.data, column.key),
              row: rowData.data
            }
          "
        >
        </ng-container>

        <ng-template #defaultColTpl let-value>
          @if(column.format) {
          {{ column.format(value, rowData.data) }}
          } @else if(getFilterType(column) === 'date') { {{ value | date }}}
          @else if (getFilterType(column) === 'boolean') {
          <kon-boolean-column [value]="value" />
          } @else { {{ value }}}
        </ng-template>
      </td>

      <td
        *ngIf="rowData.rowActions as actions"
        [ngClass]="{
          '!px-3 !py-0.5 bg-gray-50': true,
          'sm:sticky sm:right-0 sm:opacity-0 sm:group-hover/row:opacity-100':
            actions.length > 0
        }"
      >
        <div class="flex items-center justify-end">
          <ng-container *ngFor="let action of actions">
            <button
              pButton
              type="button"
              [ngClass]="[
                'row-action-button',
                'hidden',
                'sm:flex',
                'p-button-sm',
                'p-button-text',
                'p-button-' + (action.color ?? 'primary'),
                'p-button-rounded',
                'text-nowrap',
                action.styleClass ?? ''
              ]"
              [icon]="action.icon ?? ''"
              [label]="action.showRowLabel ? action.label : ''"
              [routerLink]="action.routerLink"
              [queryParams]="action.queryParams"
              [pTooltip]="action.label"
              [tooltipPosition]="'bottom'"
              [tooltipOptions]="{ showDelay: 300 }"
              [disabled]="action.disabled"
              (click)="
                  $event.stopPropagation(); action.command?.()
                "
            ></button>
          </ng-container>

          <ng-container *ngIf="rowData.menuItems as menuItems">
            <button
              *ngIf="menuItems.length > 0"
              pButton
              type="button"
              class="p-button-sm p-button-text p-button-secondary p-button-rounded"
              icon="pi pi-ellipsis-v"
              (click)="$event.stopPropagation(); menu.toggle($event)"
            ></button>

            <p-menu
              #menu
              [model]="menuItems"
              [popup]="true"
              [appendTo]="'body'"
            ></p-menu>
          </ng-container>
        </div>
      </td>
    </ng-template>
  </ng-template>

  <ng-template pTemplate="paginatorleft">
    @if(showActiveFilters) {
    <div class="flex items-center gap-1 w-full md:w-auto">
      @for (filter of activeFilters | keyvalue; track filter.key) {
      <p-chip
        [label]="filter.value.label + ' (' + filter.value.count + ')'"
        [removable]="true"
        (onRemove)="clearFilter(filter.key)"
      >
      </p-chip>
      }
    </div>
    }
    <!-- {{ query?.filters }} -->
  </ng-template>

  <ng-template pTemplate="rowexpansion" let-rowData>
    <ng-container
      *ngTemplateOutlet="
        rowExpansionTemplate ?? null;
        context: {
          $implicit: rowData.data,
          row: rowData
        }
      "
    />
  </ng-template>
</p-table>
